export default "__VITE_ASSET__DyL0ATY2__"